import { EyeOutlined, DesktopOutlined } from '@ant-design/icons';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
import React from 'react';

import { NoUserIcon } from 'components/ui/icons/NoUserIcon';
import { TooltipIconEnum } from 'entities/TableColumn';

import { TOOLTIPS_TEXT } from './texts';

type TooltipOptions = {
  text: string;
  Icon: React.ComponentType<AntdIconProps>;
};

export const TOOLTIP_MAP: Record<TooltipIconEnum, TooltipOptions> = {
  [TooltipIconEnum.defaultVisibility]: {
    text: TOOLTIPS_TEXT.DEFAULT_VISIBILITY,
    Icon: EyeOutlined,
  },
  [TooltipIconEnum.supervisorInvisibility]: {
    text: TOOLTIPS_TEXT.SUPERVISOR_INVISIBILITY,
    Icon: NoUserIcon,
  },
  [TooltipIconEnum.pivotScreenVisibility]: {
    text: TOOLTIPS_TEXT.PIVOT_SCREEN_VISIBILITY,
    Icon: DesktopOutlined,
  },
};
